import React from 'react';
import ReactDOM from 'react-dom';
import './css/normalize.css';
import './css/global.css';
import './css/colors.css';
import App from './react/App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
